import React from 'react';
import SmHumidityProps from '../../charts/humidity/sm-humidity';
import Card from '@material-ui/core/Card';
import {CardHeader, CardContent} from '@material-ui/core';

interface HumidityCardProps {
    name: string;
    value: number;
}

const HumidityCard: React.FC<HumidityCardProps> = (props: HumidityCardProps) => {

    return (
        <Card className='humidity-card'>
            <CardHeader title={props.name} className='humidity-card-header'>
            </CardHeader>
            <CardContent className='humidity-card-content'>
                <SmHumidityProps value={props.value}/>
                <div className='font-weight-bold mt-2'>
                    <span>{props.value}%</span>
                </div>
            </CardContent>
        </Card>
    )
};

export default HumidityCard;